<div class="heading skin-detail-heading" (resize)="handleResize($event)">
  @if (canGoBack()) {
    <app-button2 appearance="secondary-ghost" size="s" aria-label="Go back" (click)="handleGoBack()">
      <app-icon name="chevron-left" />
    </app-button2>
  }

  <div class="logo">
    {{ form.controls.title.value | initials: 3 }}
  </div>

  <app-input
    class="input"
    appearance="sapphire-inline"
    [inputFormControl]="form.controls.title"
    placeholder="New Group"
    [errorPlaceholder]="'Add title'"
    [withErrors]="submitted"
    size="s"
  />

  <div class="icons">
    <div [appPreventDirtyClick]="dirtyFormRef" class="contents">
      <!-- [MUST-002] 'Bug' debug quick-action hidden per task; uncomment to re-enable
      <stch-quick-action
        *ngIf="!contracted"
        appearance="sapphire-toggle"
        size="m"
        icon="bug"
        [active]="selectedTab === 'debug'"
        matTooltip="Debug"
        (onClick)="selectedTab = 'debug'"
      />
      -->

      <stch-quick-action
        *ngIf="!contracted"
        appearance="sapphire-toggle"
        size="m"
        icon="sapphire-archive2"
        [active]="form.controls.archived.value"
        [matTooltip]="form.controls.archived.value ? Labels.RestoreFromArchive : Labels.Archive"
        [disabled]="!group?.id"
        (onClick)="archive()"
      />

      <stch-trash-action
        *ngIf="!contracted"
        [deleted]="form.controls.deleted.value"
        [disabled]="!group?.id"
        (onClick)="delete()"
      />

      <!-- SBUX-785 v1: containers are not shareable (only leaf entities). Re-enable later.
      <stch-quick-action
        *ngIf="!contracted"
        appearance="sapphire-toggle"
        size="m"
        icon="sapphire-share"
        matTooltip="Share"
        [disabled]="!group?.id"
        [stchShareContextMenu]="group"
        [stchShareContextMenuDisabled]="!group?.id"
      />
      -->

      <app-button
        appearance="sapphire-secondary-ghost"
        size="xs"
        icon="sapphire-ellipsis"
        matTooltip="More options"
        ariaLabel="More options"
        [disabled]="!group?.id"
        (appGroupContextMenuDetails)="selectedTab = 'details'"
        [appGroupContextMenu]="group"
        appGroupContextMenuMode="popover"
        [appGroupContextMenuDisabled]="!group?.id"
        [printEnabled]="true"
      />
    </div>

    @if (showCloseButton) {
      <app-button appearance="sapphire-secondary-ghost" size="xs" icon="sapphire-close" (click)="handleClose()" />
    }
  </div>
</div>

@if (!group?.id && workspaceIdentity(); as identity) {
  <app-tenancy-selector
    [spaceTitle]="identity.spaceTitle"
    [spaceTenantId]="identity.spaceTenantId"
    [memberTenantId]="identity.memberTenantId"
    itemNoun="group"
    [locked]="saveInProgress || draftOwnerLocked || form.controls.uploads.value.length > 0"
    [lockedReason]="draftOwnerLocked ? 'This draft already belongs to a workspace.' : null"
    [tenantId]="sharingTenantId()"
    (tenantIdChange)="setSharingTenantId($event)"
  />
}

<app-stitch-timestamps [createdAt]="group?.createdAt" [updatedAt]="group?.updatedAt" />

<div class="tabs skin-detail-tabs">
  <app-tabs appearance="sapphire" [values]="tabsWithCounts()" [(value)]="selectedTab" size="m" />

  <div class="filler"></div>

  <!-- [MUST-001] 'Assign' button hidden per task; uncomment to re-enable

  <app-button appearance="sapphire-secondary" size="xs" label="Assign" />

  -->
  <stch-knowledge-button [active]="displayKnowledge" (click)="showKnowledge()" />
</div>

<div
  *ngIf="form"
  class="form"
  appDroppable
  appDroppableHoverClass="drag-over"
  [appDroppablePredicate]="dndPredicate"
  (appDroppableDrop)="dndDrop($event)"
>
  <div class="drop-area-border"></div>

  @if (selectedTab === 'stitch' && hasKnowledgeHubAccess()) {
    <app-entity-hub-search [contactId]="group?.id" />
  }

  <div class="form-heading">
    <div class="form-heading-nav">
      <div class="form-heading-nav-separator"></div>

    </div>

    <div *ngIf="displayKnowledge" class="form-heading-nav-underline"></div>

    <!-- One Knowledge box, rows in the skin's order: Knots · Tags · Connections. -->
    <div class="form-knowledge" [class.hidden]="!displayKnowledge || (selectedTab === 'stitch' && !hasKnowledgeHubAccess())">
      <app-knots
        class="form-knots"
        [class.hidden]="!displayKnowledge || (selectedTab === 'stitch' && !hasKnowledgeHubAccess())"
        [stitchItems]="group | toArray"
        [control]="form.controls['knots']"
        [stateKey]="StateKey.knotsList"
        [withControls]="selectedTab !== 'stitch'"
        [isHubMode]="selectedTab === 'stitch' && hasKnowledgeHubAccess()"
        [hubEntityUid]="group?.id"
      />

      <app-tags
        class="form-tags"
        [class.hidden]="!displayKnowledge || (selectedTab === 'stitch' && !hasKnowledgeHubAccess())"
        [stitchItems]="[group]"
        [control]="form.controls['tags']"
        [stateKey]="StateKey.tagsList"
        [withControls]="selectedTab !== 'stitch'"
        [isHubMode]="selectedTab === 'stitch' && hasKnowledgeHubAccess()"
        [hubEntityUid]="group?.id"
      />

      <app-connections
        class="form-knots"
        [class.hidden]="!displayKnowledge || (selectedTab === 'stitch' && !hasKnowledgeHubAccess())"
        [stitchItems]="[group]"
        [control]="form.controls['connections']"
        [stateKey]="StateKey.connectionsList"
        [withControls]="selectedTab !== 'stitch'"
        [isHubMode]="selectedTab === 'stitch' && hasKnowledgeHubAccess()"
        [hubEntityUid]="group?.id"
      />
    </div>
  </div>

  <!-- stitch-app-shell ContainerItems: the list's sort & filter on a bar of its own right above the list, on
       the far right over a 1px line, so it reads as the list's (Johanna, 2026-10-21; it sat in the tab row). -->
  <div class="container-list-bar" *ngIf="selectedTab === 'group'">
    <app-context-menu-state-indicator svgIcon="filters" appContactsListContextMenu />
  </div>
  <app-scroll
    *ngIf="(selectedTab !== 'stitch' || (permissionsLoaded() && !hasKnowledgeHubAccess()))"
    [ngSwitch]="selectedTab"
    class="form-scroll"
    (top)="displayScrollShadow = !$event"
  >
    <div *ngIf="displayScrollShadow" class="form-scroll-shadow"></div>

    <ng-template #unsavedGroupContactsTpl>
      <app-no-content-stub imageSrc="assets/placeholders/placeholder-contacts.svg">
        <div class="flex max-w-full flex-col items-center gap-2">
          <p class="text-base font-medium text-gray-900 text-center">No contacts</p>
          <p class="text-sm text-gray-600 text-center">Save your group to start adding contacts</p>
        </div>
      </app-no-content-stub>
    </ng-template>

    <app-contacts-list
      [tenantItems]="[group]"
      *ngSwitchCase="'group'"
      class="h-full"
      [filters]="contactsFilters"
      [notFoundTemplate]="group?.id ? undefined : unsavedGroupContactsTpl"
      (openContact)="handleClickItem($event)"
      (clickContact)="handleClickItem($event)"
      (doubleClickContact)="handleDblClickItem($event)"
    />

    <div *ngSwitchCase="'details'" class="form-kit" [class.contracted]="contracted">
      <section class="form-kit-section">
        @if (false) {
          <!-- HIDDEN FOR VERSION 1-->
          <div class="form-kit-field">
            <span class="form-kit-label">Parent Group</span>
            <app-autocomplete-input
              appearance="sapphire-outline"
              placeholder="Parent Group"
              [suggestions]="parentSuggestions"
              [inputFormControl]="form.controls.parentId"
              size="s"
              [withErrors]="submitted"
              [validationMessages]="{
                circular: 'Circular dependency',
                deep: 'Too deep',
              }"
              [withClear]="true"
            />
          </div>
        }

        <div class="form-kit-inline">
          <app-checkbox2 [formControl]="form.controls.vip" label="VIP Group" size="s" />
        </div>

        <div class="form-kit-field">
          <span class="form-kit-label">Country</span>
          <app-input
            class="form-details-row-input"
            [inputFormControl]="form.controls.country"
            [withClear]="true"
            placeholder="Enter country"
          />
        </div>

        <div class="form-kit-field">
          <span class="form-kit-label">Email</span>

          <app-controls-list
            [items]="form.controls.emails"
            [itemTemplateRef]="emailItemTemplate"
            (onAddItem)="handleAddItem('emails', $event)"
          >
            <ng-template #emailItemTemplate let-emailControl="item">
              <app-input-side-options
                [sideFormControl]="emailControl['controls'].category"
                [sideOptions]="contactInfoTypes"
              >
                <app-input
                  [inputFormControl]="emailControl['controls'].value"
                  [customStyles]="{ border: 'none' }"
                  placeholder="Enter email"
                />
              </app-input-side-options>
            </ng-template>
          </app-controls-list>
        </div>

        <div class="form-kit-field">
          <span class="form-kit-label">Phone Number</span>

          <app-controls-list
            [items]="form.controls.phones"
            [itemTemplateRef]="phoneNumberItemTemplate"
            (onAddItem)="handleAddItem('phones', $event)"
          >
            <ng-template #phoneNumberItemTemplate let-phoneNumberControl="item">
              <app-input-side-options
                [sideFormControl]="phoneNumberControl.controls.category"
                [sideOptions]="contactInfoTypes"
              >
                <app-input
                  class="w-full"
                  [inputFormControl]="phoneNumberControl.controls.value"
                  [customStyles]="{ border: 'none' }"
                  type="tel"
                  placeholder="Phone Number"
                />
              </app-input-side-options>
            </ng-template>
          </app-controls-list>
        </div>

        <div class="form-kit-field">
          <span class="form-kit-label">Address</span>
          <app-input
            appearance="sapphire-outline"
            [inputFormControl]="form.controls.address"
            placeholder="Address"
            [withErrors]="submitted"
            [withClear]="true"
            size="s"
          />
        </div>

        <div class="form-kit-field">
          <span class="form-kit-label">Website</span>
          <app-input
            appearance="sapphire-outline"
            [inputFormControl]="form.controls.website"
            placeholder="Website"
            [withErrors]="submitted"
            [withClear]="true"
            size="s"
          />
        </div>
      </section>

      <section class="form-kit-section">
        <stch-item-description-field
          [control]="form.controls.description"
          [item]="group"
          [tagsControl]="form.controls['tags']"
          [knotsControl]="form.controls['knots']"
        />
      </section>
    </div>

    <app-attachments-list
      class="form-attachments"
      *ngSwitchCase="'attachments'"
      [stitchItem]="stitchItem"
      [inputControl]="form.controls.uploads"
      [tenantItems]="tenantCarrier()"
      [contextMenuStateVariant]="attachmentsMenuStateVariant"
      (listStateChange)="attachmentsListState = $event"
      (onClickItem)="handleClickItem($event)"
      (onDblClickItem)="handleDblClickItem($event)"
      (uploading)="onUploadingChange($event)"
    />

    <app-context-menu-state-indicator
      *ngSwitchCase="'stitch'"
      class="block ml-auto w-fit mt-5 mr-4"
      svgIcon="filters"
      appStitchListContextMenu
      (appStitchListContextMenuChange)="stitchListState = $event"
    />

    <app-linked-info-list
      *ngSwitchCase="'stitch'"
      class="form-linked-info"
      [stitch]="group"
      [state]="stitchListState"
      [placeholderSubtitle]="group?.id ? undefined : 'Save to start Stitching items'"
      (clickStitchItem)="handleClickItem($event)"
      (dblClickStitchItem)="handleDblClickItem($event)"
    />

    <stch-comments *ngSwitchCase="'comments'" class="form-linked-info" [stitch]="group" />

    <stch-json-viewer *ngSwitchCase="'debug'" [json]="group?.debug" />
  </app-scroll>

  @if (selectedTab === 'stitch' && hasKnowledgeHubAccess()) {
    <app-stitch-hub
      [stitch]="group"
      (clickStitchItem)="handleClickItem($event)"
      (dblClickStitchItem)="handleDblClickItem($event)"
    />
  }

  <stch-save-cancel-panel
    [enabled]="!pristine"
    [uploading]="isUploading()"
    (onCancel)="handleCancel()"
    (onSave)="handleSubmit()"
  />

</div>

<!-- stitch-app-shell breadcrumbs footer in the main view, as on every detail page. -->
@if (navigation.enabled && stitchItem?.id) {
  <app-detail-breadcrumbs
    [crumbs]="breadcrumbs()"
    [status]="form.controls.archived.value ? 'Archived' : form.controls.deleted.value ? 'Trash' : undefined"
  />
}
